// extracted by mini-css-extract-plugin
export var createdDate = "_ls-1";
export var divider = "_ls-2";
export var headerDivider = "_ls-3";
export var messagesCard = "_ls-0";
export var messagesContainer = "_ls-7";
export var messagesContainerWrapper = "_ls-4";
export var pointerCapturingButtonBoxes = "_ls-a";
export var showLeftPanelButton = "_ls-9";
export var showMoreButton = "_ls-c";
export var showMoreButtonContainer = "_ls-b";
export var summaryTitle = "_ls-6";
export var systemMessageCardWrapper = "_ls-d";
export var topButtons = "_ls-8";
export var withPadding = "_ls-5";